module.exports = __webpack_public_path__ + "media/images/icons/white_arrow-610ad1040cd1ce5a0652f2988996d2e9.svg";